<template>
    <div class="summary">
        <div class="summary__info">
            <span class="summary__label">Brawo skonfigurowałaś (eś) profil swojego dziecka. <br/>W każdym momencie możesz zmienić ustawienia wchodząc w strefę rodzica.</span>
        </div>

        <div class="summary__zones">
            <div class="summary__activity">
                <IconChart class="summary__activity-icon"></IconChart>
                <span class="summary__label">Wchodząc do strefy aktywności dowiesz się w co Twoje dziecko bawi się w aplikacji</span>
            </div>
            <div class="summary__favorites">
                <IconFavoriteBig class="summary__favorites-icon"></IconFavoriteBig>
                <span class="summary__label">Możesz polecić swojemu dziecku treści, dodając je do ulubionych</span>
            </div>
        </div>

        <div class="summary__btns">
            <div class="summary__add" @click="showAvatarSelection">
                <IconAdd class="summary__add-icon"></IconAdd>
                Dodaj profil dziecka
            </div>

            <router-link class="summary__btn" to="/wybierz-profil"><span>Przejdź do zabawy</span></router-link>
        </div>

        <ProfileAvatarList v-if="isModalAvatar" @closeModal="closeModal"></ProfileAvatarList>
    </div>
</template>

<script>
import IconAdd from "../elements/icons/IconAdd.vue";
import ProfileAvatarList from "./ProfileAvatarList.vue";
import IconFavoriteBig from "../elements/icons/IconFavoriteBig.vue";
import IconChart from "../elements/icons/IconChart.vue";

export default {
    name: "ProfileNewSummary",
    components: {
        IconAdd,
        ProfileAvatarList,
        IconFavoriteBig,
        IconChart
    },
    data() {
        return {
            isModalAvatar: false
        }
    },
    methods: {
        showAvatarSelection() {
            this.isModalAvatar = true;
            this.$store.dispatch("changeModalBackdrop", true);
        },
        closeModal() {
            this.isModalAvatar = false;
            this.$store.dispatch("changeModalBackdrop", false);  
            this.$store.dispatch("changeNewProfileStep", 1);
        }
    }
};
</script>